module.exports = __webpack_public_path__ + "static/media/logo.ee62fa99.svg";